(function () {
  if (window.BottleBuddyBundlesLoadedV5) return;
  window.BottleBuddyBundlesLoadedV5 = true;

  var SELECTORS = {
    block: '[data-bb-bundle-block]',
    offer: '[data-bb-offer]',
    mainVariantSelect: '[data-bb-main-variant-select]',
    giftSelect: '[data-bb-gift-select]',
    buyNow: '[data-bb-buy-now]',
    error: '[data-bb-error]'
  };

  function init() {
    document.querySelectorAll(SELECTORS.block).forEach(function (block) {
      refreshOfferState(block);
      maybeHideDynamicCheckout(block);
      bindBundleForm(block);
    });
  }

  function getProductDetails(block) {
    return block.closest('.product-details') || block.closest('[data-testid="product-information-details"]') || block.closest('.shopify-section');
  }

  function getFormFromBlock(block) {
    var productDetails = getProductDetails(block);
    return productDetails ? productDetails.querySelector('product-form-component form') : null;
  }

  function getProductFormFromBlock(block) {
    var form = getFormFromBlock(block);
    return form ? form.closest('product-form-component') : null;
  }

  function bindBundleForm(block) {
    var form = getFormFromBlock(block);
    var productForm = form ? form.closest('product-form-component') : null;

    if (!form || !productForm) return;

    // IMPORTANT FIX:
    // This theme adds the native product through product-form-component's on:submit handler.
    // We remove that handler only for the product form that has this bundle block,
    // otherwise Shopify adds the native bottle once AND this script adds the bundle again.
    if (productForm.hasAttribute('on:submit')) {
      productForm.dataset.bbOriginalOnSubmit = productForm.getAttribute('on:submit') || '';
      productForm.removeAttribute('on:submit');
    }

    productForm.setAttribute('data-bb-bundle-product-form', 'true');

    if (form.dataset.bbBundleSubmitBound !== 'true') {
      form.dataset.bbBundleSubmitBound = 'true';
      form.addEventListener('submit', handleBundleSubmit, true);
    }
  }

  function maybeHideDynamicCheckout(block) {
    if (block.dataset.hideDynamicCheckout !== 'true') return;

    var productDetails = getProductDetails(block);
    if (!productDetails) return;

    productDetails.querySelectorAll('.accelerated-checkout-block').forEach(function (acceleratedCheckout) {
      acceleratedCheckout.style.display = 'none';
      acceleratedCheckout.setAttribute('data-bb-hidden-dynamic-checkout', 'true');
    });
  }

  function refreshOfferState(block) {
    var checked = block.querySelector(SELECTORS.offer + ' input[type="radio"]:checked');
    var selectedOffer = checked ? checked.closest(SELECTORS.offer) : block.querySelector(SELECTORS.offer);

    if (!selectedOffer) return;

    block.querySelectorAll(SELECTORS.offer).forEach(function (offer) {
      var isActive = offer === selectedOffer;
      offer.classList.toggle('is-active', isActive);
      offer.setAttribute('aria-checked', isActive ? 'true' : 'false');
    });
  }

  function getSelectedOffer(block) {
    var checked = block.querySelector(SELECTORS.offer + ' input[type="radio"]:checked');
    return checked ? checked.closest(SELECTORS.offer) : block.querySelector(SELECTORS.offer + '.is-active') || block.querySelector(SELECTORS.offer);
  }

  function getBundleBlockForForm(form) {
    var productForm = form.closest('product-form-component');
    if (!productForm) return null;

    var productDetails = productForm.closest('.product-details') || productForm.closest('[data-testid="product-information-details"]') || productForm.closest('.shopify-section');
    if (!productDetails) return null;

    return productDetails.querySelector(SELECTORS.block);
  }

  function getProductQuantity(form, productForm) {
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? Number(quantityInput.value) : 0;

    if (!quantity && productForm && productForm.dataset.quantityDefault) {
      quantity = Number(productForm.dataset.quantityDefault);
    }

    return Math.max(1, quantity || 1);
  }

  function getSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component'))
      .map(function (component) { return component.dataset.sectionId; })
      .filter(Boolean)
      .filter(function (value, index, array) { return array.indexOf(value) === index; });
  }

  function showError(block, message) {
    var error = block.querySelector(SELECTORS.error);
    if (!error) return;
    error.hidden = false;
    error.textContent = message || 'Something went wrong. Please try again.';
  }

  function clearError(block) {
    var error = block.querySelector(SELECTORS.error);
    if (!error) return;
    error.hidden = true;
    error.textContent = '';
  }

  function setLoading(form, block, isLoading) {
    if (form) {
      form.querySelectorAll('button[type="submit"], button[name="add"]').forEach(function (button) {
        button.disabled = isLoading;
        button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      });
    }

    if (block) {
      block.querySelectorAll(SELECTORS.buyNow).forEach(function (button) {
        button.disabled = isLoading;
        button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      });
    }
  }

  function getSelectedOption(select) {
    if (!select || !select.value) return null;

    var option = select.options[select.selectedIndex];
    if (!option || option.disabled) return null;

    return {
      id: Number(select.value),
      variantTitle: option.dataset.variantTitle || option.textContent.trim(),
      productTitle: select.dataset.displayProductTitle || select.dataset.productTitle || '',
      bottleLabel: select.dataset.bottleLabel || 'Bottle'
    };
  }

  function addMainBottleItems(items, selectedOffer, bundleUnits, bundleName, bundleKey, groupId, bundlePriceText) {
    var selects = Array.from(selectedOffer.querySelectorAll(SELECTORS.mainVariantSelect));

    if (!selects.length) {
      throw new Error('Please select the main bottle product in the block settings.');
    }

    var requiredMainQuantity = selects.length * bundleUnits;
    var shouldLockMainQuantity = selectedOffer.dataset.offerKey === 'duo';

    selects.forEach(function (select, index) {
      var selected = getSelectedOption(select);

      if (!selected) {
        throw new Error('Please select an available bottle option.');
      }

      var bottleLabel = selected.bottleLabel || 'Bottle ' + (index + 1);

      items.push({
        id: selected.id,
        quantity: bundleUnits,
        properties: {
          Bundle: bundleName,
          Product: selected.productTitle,
          Bottle: bottleLabel,
          Option: selected.variantTitle,
          '_bundle_key': bundleKey,
          '_bundle_offer_key': selectedOffer.dataset.offerKey || bundleKey,
          '_bundle_group': groupId,
          '_bundle_role': 'main',
          '_bundle_required_main_quantity': String(requiredMainQuantity),
          '_bundle_offer_price': bundlePriceText || '',
          '_bundle_locked_quantity': shouldLockMainQuantity ? 'true' : 'false'
        }
      });
    });

    return requiredMainQuantity;
  }

  function addGiftItem(items, block, selectedOffer, bundleUnits, bundleName, bundleKey, groupId, bundlePriceText, requiredMainQuantity) {
    if (selectedOffer.dataset.giftEnabled !== 'true') return;

    var giftSelectId = selectedOffer.dataset.giftSelectId;
    var giftSelect = giftSelectId ? block.querySelector('#' + window.CSS.escape(giftSelectId)) : block.querySelector(SELECTORS.giftSelect);
    var selectedGift = getSelectedOption(giftSelect);

    if (!selectedGift) {
      throw new Error('Please select an available free gift option.');
    }

    var giftQuantity = Math.max(1, Number(selectedOffer.dataset.giftQuantity || 1)) * bundleUnits;

    items.push({
      id: selectedGift.id,
      quantity: giftQuantity,
      properties: {
        Bundle: bundleName,
        'Free Gift': 'Yes',
        Product: selectedGift.productTitle,
        'Gift Option': selectedGift.variantTitle,
        '_bundle_key': bundleKey,
        '_bundle_offer_key': selectedOffer.dataset.offerKey || bundleKey,
        '_bundle_group': groupId,
        '_bundle_role': 'gift',
        '_bundle_free_gift': 'true',
        '_bundle_required_main_quantity': String(requiredMainQuantity || 0),
        '_bundle_offer_price': bundlePriceText || '',
        '_bundle_locked_quantity': 'true'
      }
    });
  }

  function buildBundleItems(block, form, productForm) {
    var selectedOffer = getSelectedOffer(block);
    if (!selectedOffer) throw new Error('Please select a bundle option.');

    var bundleUnits = getProductQuantity(form, productForm);
    var bundleName = selectedOffer.dataset.bundleName || 'Bundle';
    var bundlePriceText = selectedOffer.dataset.bundlePrice || '';
    var bundleKey = selectedOffer.dataset.offerKey || 'bundle';
    var groupId = 'bb-' + Date.now() + '-' + Math.random().toString(16).slice(2);
    var items = [];

    var requiredMainQuantity = addMainBottleItems(items, selectedOffer, bundleUnits, bundleName, bundleKey, groupId, bundlePriceText);
    addGiftItem(items, block, selectedOffer, bundleUnits, bundleName, bundleKey, groupId, bundlePriceText, requiredMainQuantity);

    if (!items.length) {
      throw new Error('No bundle items found. Please check bundle settings.');
    }

    return items;
  }

  async function addBundleToCart(block, form, options) {
    options = options || {};
    var productForm = form.closest('product-form-component');
    var sectionIds = getSectionIds();
    var addUrl = window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url ? window.Theme.routes.cart_add_url : '/cart/add.js';
    var items;

    try {
      items = buildBundleItems(block, form, productForm);
    } catch (error) {
      showError(block, error && error.message ? error.message : 'Please check your bundle selections.');
      return;
    }

    var payload = {
      items: items,
      sections: sectionIds.join(','),
      sections_url: window.location.pathname
    };

    clearError(block);
    setLoading(form, block, true);

    try {
      var response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });

      var addData = await response.json();

      if (!response.ok || addData.status) {
        var message = addData.description || addData.message || 'Bundle could not be added to cart.';
        throw new Error(message);
      }

      var cartResponse = await fetch('/cart.js', {
        headers: { Accept: 'application/json' }
      });
      var cart = await cartResponse.json();

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'bottle-buddy-bundles',
            data: {
              source: 'bottle-buddy-bundles',
              itemCount: cart.item_count,
              sections: addData.sections || {}
            }
          }
        })
      );

      if (options.checkout === true) {
        window.location.href = '/checkout';
      }
    } catch (error) {
      showError(block, error && error.message ? error.message : 'Bundle could not be added to cart.');
    } finally {
      setLoading(form, block, false);
    }
  }

  function handleBundleSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var block = getBundleBlockForForm(form);
    if (!block) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    addBundleToCart(block, form, { checkout: false });
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var select = event.target.closest(SELECTORS.mainVariantSelect + ', ' + SELECTORS.giftSelect);
    if (select) {
      event.stopPropagation();
      return;
    }

    var offer = event.target.closest(SELECTORS.offer);
    if (offer) {
      var block = offer.closest(SELECTORS.block);
      var input = offer.querySelector('input[type="radio"]');

      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (block) refreshOfferState(block);
      return;
    }

    var buyNowButton = event.target.closest(SELECTORS.buyNow);
    if (buyNowButton) {
      var buyNowBlock = buyNowButton.closest(SELECTORS.block);
      var form = buyNowBlock ? getFormFromBlock(buyNowBlock) : null;

      if (!buyNowBlock || !form) return;

      event.preventDefault();
      event.stopPropagation();
      addBundleToCart(buyNowBlock, form, { checkout: true });
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (!(event.target instanceof Element)) return;

    var offer = event.target.closest(SELECTORS.offer);
    if (!offer) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();

    var input = offer.querySelector('input[type="radio"]');
    var block = offer.closest(SELECTORS.block);

    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (block) refreshOfferState(block);
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof Element)) return;
    if (!input.matches(SELECTORS.offer + ' input[type="radio"]')) return;

    var block = input.closest(SELECTORS.block);
    if (block) refreshOfferState(block);
  });

  // Backup submit listener. The form-level listener handles the main case,
  // this only catches forms that are injected later before init runs again.
  document.addEventListener('submit', handleBundleSubmit, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
